import { render, staticRenderFns } from "./animation-spine-seasonpass-kingspass.vue?vue&type=template&id=45ac2694"
import script from "./animation-spine-seasonpass-kingspass.vue?vue&type=script&lang=js"
export * from "./animation-spine-seasonpass-kingspass.vue?vue&type=script&lang=js"
import style0 from "./animation-spine-seasonpass-kingspass.vue?vue&type=style&index=0&id=45ac2694&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports